import { styled } from '@mui/material';

export const ProjectsListHeader = styled('div')({
  padding: '6rem 0 2rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});
